import React from 'react';

import { colors, fonts, line } from '../theme';
import { logoWhite, APP_STORE_URL, PLAY_STORE_URL } from '../data';

const AppleGlyph = () => (
  <svg width="22" height="26" viewBox="0 0 22 26" fill="currentColor" aria-hidden="true" style={{ display: 'block' }}>
    <path d="M17.5 13.8c0-3 2.4-4.4 2.5-4.5-1.4-2-3.5-2.3-4.2-2.3-1.8-.2-3.5 1-4.4 1-.9 0-2.3-1-3.8-1-2 0-3.8 1.1-4.8 2.9-2 3.5-.5 8.8 1.5 11.6 1 1.4 2.1 3 3.6 2.9 1.4-.1 2-.9 3.7-.9s2.2.9 3.7.9 2.5-1.4 3.5-2.8c1.1-1.6 1.5-3.1 1.6-3.2-.1 0-3-1.2-3-4.5zM14.7 5c.8-1 1.3-2.3 1.2-3.7-1.1.1-2.5.8-3.3 1.7-.7.8-1.4 2.2-1.2 3.5 1.2.1 2.5-.6 3.3-1.5z" />
  </svg>
);

export default function Download() {
  return (
    <section id="get" style={{ position: 'relative', borderTop: line.faint, overflow: 'hidden' }}>
      <div
        style={{
          position: 'absolute',
          left: -160,
          bottom: -160,
          width: 560,
          height: 560,
          borderRadius: '0 9999px 9999px 0',
          background: 'radial-gradient(circle at 30% 50%,rgba(49,56,236,.22),transparent 65%)',
        }}
      />
      <div
        style={{
          position: 'absolute',
          right: -120,
          top: -120,
          width: 440,
          height: 440,
          borderRadius: '9999px 0 0 9999px',
          background: 'radial-gradient(circle at 70% 50%,rgba(232,99,43,.16),transparent 65%)',
        }}
      />
      <div
        className="lyfe-reveal lyfe-wrap lyfe-sec"
        style={{ position: 'relative', maxWidth: 900, margin: '0 auto', padding: '150px 40px', textAlign: 'center' }}>
        <img src={logoWhite} alt="Lyfe" style={{ height: 30, margin: '0 auto 40px', display: 'block' }} />
        <h2
          style={{
            fontFamily: fonts.serif,
            fontWeight: 300,
            fontSize: 'clamp(44px,6vw,84px)',
            lineHeight: 1.0,
            letterSpacing: '-.015em',
          }}>
          Lyfe is how the night
          <br />
          <span style={{ fontStyle: 'italic' }}>really</span> starts.
        </h2>
        <p style={{ fontSize: 19, lineHeight: 1.55, color: colors.muted, margin: '30px auto 0', maxWidth: 520 }}>
          Download Lyfe and find your next stop in seconds — free shots, two-for-ones and the spots that are actually
          popping, all over Miami.
        </p>
        <div style={{ display: 'flex', gap: 16, justifyContent: 'center', marginTop: 44, flexWrap: 'wrap' }}>
          <a
            className="lyfe-btn"
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              background: colors.ink,
              color: colors.bg,
              padding: '14px 26px',
              borderRadius: 14,
              textDecoration: 'none',
            }}>
            <AppleGlyph />
            <span style={{ textAlign: 'left' }}>
              <span style={{ display: 'block', fontSize: 11, letterSpacing: '.04em', opacity: 0.7 }}>
                Download on the
              </span>
              <span style={{ display: 'block', fontSize: 18, fontWeight: 600, lineHeight: 1.1 }}>App Store</span>
            </span>
          </a>
          <a
            className="lyfe-btn lyfe-ghost"
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              border: '1px solid rgba(255,255,255,.28)',
              color: colors.ink,
              padding: '14px 26px',
              borderRadius: 14,
              textDecoration: 'none',
            }}>
            <span style={{ fontSize: 20, lineHeight: 1, color: colors.blue }}>▶</span>
            <span style={{ textAlign: 'left' }}>
              <span style={{ display: 'block', fontSize: 11, letterSpacing: '.04em', opacity: 0.7 }}>Get it on</span>
              <span style={{ display: 'block', fontSize: 18, fontWeight: 600, lineHeight: 1.1 }}>Google Play</span>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}
